import { ButtonTriggerEvent } from '../../../common/components';
import { Account } from '../../../models/admin/account';

export class AddEventbriteEventsModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class AddEventbriteEventsModalData {
    constructor(account, events) {
        this.account = account;
        this.events = events;
    }
    events: any[];
    account: Account;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/add.eventbrite.events.modal/add.eventbrite.events.modal.provider.ts